import role3Schema from '../../../../assets/forms/role-3.form.json';
import { SHEET_KEYS } from '../../../models/sheet-keys';
import { ConditionalControl } from '../conditional/conditional-field.model';
import { makeSchemaProjector } from './make-schema-projector';

/**
 * Strips role 3's conditionally hidden fields from the persisted slice at
 * submit, so orphaned values are never submitted as XBRL facts. Rules are read
 * from the form JSON's `conditional` blocks — the SAME source the role-3
 * component renders from — via the shared evaluator.
 *
 * **As of 2026-08-04 role 3 declares NO `conditional` blocks, so this projector
 * is a pass-through** (`makeSchemaProjector` pre-filters to the conditional
 * controls, leaving an empty rule set; `project` returns a shallow copy
 * unchanged). Every one of the sheet's nine fields is now always visible:
 *   - #f3 `DisclosureOfForeignStockExchange` + #f4 `TypeOfMarketListedOnBursaMalaysia`
 *     — always visible as of 2026-08-04 (both were gated on
 *     `TypeOfExchangeOnWhichCompanyIsListed`; blocks removed on request).
 *   - #f6 `ExplanationOfOtherSecuritiesListedOnShariahComplaintSecuritiesList`
 *     — always visible as of 2026-07-17 (was gated on the Shariah selector).
 *
 * Deliberately left REGISTERED rather than deleted: the stripping behaviour is
 * derived from the schema, so re-adding a `conditional` block to role-3.form.json
 * resumes it automatically with no code change — which is exactly how #f6's and
 * #f3/#f4's removals were absorbed. The cost is one shallow copy per submit.
 */
export const role3StockExchangeProjector = makeSchemaProjector(
  SHEET_KEYS.stockExchangeDisclosure,
  (role3Schema as { controls: ConditionalControl[] }).controls
);
